import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LogoutButton } from '@/features/auth/components/LogoutButton';

/**
 * Main app shell layout with dark sidebar navigation
 */
export function RootLayout() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar - Dark theme */}
      <aside className="fixed inset-y-0 left-0 w-56 bg-slate-900">
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="px-4 py-3 border-b border-slate-700">
            <h1 className="text-lg font-semibold text-white tracking-tight">EasyHelp</h1>
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-2 py-2">
            <NavLink
              to="/inbox"
              className={({ isActive }) =>
                `flex items-center px-3 py-2 rounded-md text-sm transition-colors ${
                  isActive
                    ? 'bg-slate-800 text-white font-medium'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                }`
              }
            >
              <svg
                className="w-4 h-4 mr-2.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                />
              </svg>
              Inbox
            </NavLink>
          </nav>

          {/* User section */}
          <div className="px-2 py-3 border-t border-slate-700">
            <div className="flex items-center justify-between px-2">
              <div className="flex items-center gap-2.5 min-w-0">
                <div className="w-7 h-7 bg-slate-700 text-slate-200 rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-medium">
                    {user?.email?.charAt(0).toUpperCase() ?? '?'}
                  </span>
                </div>
                <div className="text-xs truncate">
                  <p className="text-slate-300 truncate">{user?.email}</p>
                </div>
              </div>
              <LogoutButton />
            </div>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="pl-56">
        <Outlet />
      </main>
    </div>
  );
}
